/* eslint-disable import/no-unresolved */
import { styled } from 'styled-components';

export const SectionInfoFaqs = styled.section`
  background-color: ${({ theme }) => theme.colors.blue300};

  .info-faqs__container {
    display: flex;
    flex-direction: column;
    gap: clamp(2.125rem, 3.333vw + 1.125rem, 3.625rem);
    align-items: center;
    padding-bottom: 56px;
  }
`;

export const InfoFaqsContent = styled.div`
  display: flex;
  gap: clamp(16px, calc(16px + (120px * (100vw - 768px) / 1152px)), 136px);
  width: 100%;
  height: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    flex-direction: column;
    gap: 30px;
  }
`;

export const InfoFaqsLeft = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 494px;
  padding-top: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    max-width: 100%;
  }
`;

export const InfoFaqsRight = styled.div`
  position: sticky;
  top: 50px;
  height: 100%;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    display: none;
  }
`;

export const InfoFaqsImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 300px;
  max-height: 480px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 18px 0 rgba(61, 84, 104, 0.11);
  background: ${({ theme }) => theme.colors.lightGrey};
  padding: 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoFaqsImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  transition: opacity 0.5s ease-in-out;
`;

export const InfoFaqsItem = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.blue500};
  padding: 12px 16px 12px 0px;
  position: relative;

  &:last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.blue500};
  }
`;

export const InfoFaqsProgressBar = styled.div`
  position: absolute;
  top: -3px;
  left: 0;
  right: 0;
  height: 3px;
  overflow: hidden;
  z-index: 10;
  border-radius: 2px 2px 0 0;
`;

export const InfoFaqsProgressBarFill = styled.div`
  height: 100%;
  width: ${({ $progress }) => $progress}%;
  background-color: ${({ theme }) => theme.colors.secondary || '#1E96FC'};
  transition: width 0.1s ease-out;
  min-width: 0;
  border-radius: 2px 0 0 0;
`;

export const InfoFaqsTitle = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  align-items: center;

  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondary};

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile || '480px'}) {
    gap: 15px;
  }
`;

export const InfoFaqsIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transition: transform 0.4s ease-in-out;
  transform: rotate(${({ $isOpen }) => ($isOpen ? '0deg' : '180deg')});
`;

export const InfoFaqsIcon = styled.img`
  width: clamp(1.125rem, 4.167vw - 0.125rem, 1.875rem);
`;

export const InfoFaqsText = styled.div`
  font-size: clamp(1.125rem, 1.389vw + 0.708rem, 1.375rem);
  font-weight: 700;
  line-height: 160%;
`;

export const InfoFaqsDesc = styled.div`
  font-size: 16px;
  line-height: 26px;
  padding: 0px 0px;
  overflow: hidden;
  height: 0px;
  transition: all 0.5s ease-out;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    padding: 0px;
  }

  ${({ $show, theme }) =>
    $show &&
    ` 
    height: auto;
    padding: 10px 0px 18px;

    @media (max-width: ${theme.breakpoint?.tablet || '768px'}) {
      padding: 16px 0px 16px 0px;
    }
  `};
`;

export const InfoFaqsItemImageWrapper = styled.div`
  display: none;
  margin-top: 16px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 18px 0 rgba(61, 84, 104, 0.11);
  background: ${({ theme }) => theme.colors.lightGrey};
  padding: 10px 0 0;
  height: 300px;
  align-items: center;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet || '768px'}) {
    display: ${({ $show }) => ($show ? 'flex' : 'none')};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile || '480px'}) {
    height: 345px;
    border-radius: 16px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint?.mobile || '380px'}) {
    height: 285px;
    border-radius: 8px;
  }
`;

export const InfoFaqsItemImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;
